<template>
  <!-- 编辑网点 -->
  <div class="page-container">
    <div class="page-top-tool">
      <el-page-header @back="goBack" content="编辑财务记录"></el-page-header>
    </div>
    <div class="form-layout">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户ID：" prop="user_no">
          <div>
            {{form.user_no}}
          </div>
        </el-form-item>
        <el-form-item label="名片二维码" prop="qrcode">
          <img v-if="form.qrcode" :src="`${baseurl}/${form.qrcode}`" class="prview-pic">
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" size="mini" placeholder="请输入姓名" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" size="mini" placeholder="请输入手机号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="多电话">
          <el-radio-group v-model="form.is_multiple_phone" size="mini">
            <el-radio-button label="1">开启</el-radio-button>
            <el-radio-button label="-1">关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_multiple_phone == '1'" label="其他电话">
          <div>
            <div v-for="(item, index) in phoneList" :key="index">
              <el-input v-model="item.number" size="mini" placeholder="请输入" style="width: 300px;"></el-input>
              <el-button v-if="(index == phoneList.length - 1)" size="mini" plain style="margin-left: 10px;" @click="addPhoneItem" icon="el-icon-plus"></el-button>
              <el-button v-else-if="(index < phoneList.length - 1) && phoneList.length > 1" size="mini" plain style="margin-left: 10px;" @click="removePhoneItem(index)" icon="el-icon-minus" type="danger"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="头像" prop="photo_pic">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleAvatarSuccess"
            :on-error="handleError">
            <img v-if="form.photo_pic" :src="`${baseurl}/${form.photo_pic}`" class="prview-pic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="form.sex" size="mini">
            <el-radio-button label="1">男</el-radio-button>
            <el-radio-button label="2">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否代理" prop="is_agent">
          <el-radio-group v-model="form.is_agent" size="mini" @input="handleAgentChange">
            <el-radio-button label="-1">否</el-radio-button>
            <el-radio-button label="1">合伙人</el-radio-button>
            <el-radio-button label="2">二级代理</el-radio-button>
            <el-radio-button label="3">一级代理</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_agent != '-1'" label="审核状态" prop="agent_state">
          <el-radio-group v-model="form.agent_state" size="mini">
            <el-radio-button label="-1">驳回申请</el-radio-button>
            <el-radio-button label="1">待审核</el-radio-button>
            <el-radio-button label="2">审核通过</el-radio-button>
            <el-radio-button label="3">已冻结</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_agent != '-1'" label="邀请码" prop="agent_level">
          <div>
            {{ form.invite_code }}
            <span v-if="!form.invite_code_url" class="copy-link" v-clipboard:copy="form.invite_code" v-clipboard:success="copyInviteCode" v-clipboard:error="onCopyError">复制并创建二维码</span>
          </div>
        </el-form-item>
        <el-form-item v-if="form.is_agent != '-1'" label="邀请二维码" prop="wxcode">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleInviteCodeSuccess"
            :on-error="handleError">
            <img v-if="form.invite_code_url" :src="`${baseurl}/${form.invite_code_url}`" class="prview-pic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="form.is_agent == '1'" label="收款账号" prop="account_num">
          <el-input v-model="form.account_num" size="mini" placeholder="请输入佣金收款账号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item v-if="form.is_agent == '1'" label="账号类型" prop="account_type">
          <el-radio-group v-model="form.account_type" size="mini">
            <el-radio-button label="3">银行卡</el-radio-button>
            <el-radio-button label="1">支付宝</el-radio-button>
            <el-radio-button label="2">微信</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_agent == '1' && form.account_type == '3'" label="开户行" prop="account_notes">
          <el-input v-model="form.account_notes" size="mini" placeholder="请输入银行卡开户行" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item v-if="form.is_agent == '2' || form.is_agent == '3'" label="预存额度" prop="agent_level">
          <div>{{ form.fee_balance }}</div>
        </el-form-item>
        <el-form-item label="名片版本" prop="card_version">
          <el-radio-group v-model="form.card_version" size="mini" @input="handleCardVersionChange">
            <el-radio-button label="1">个人版</el-radio-button>
            <el-radio-button label="2">企业版</el-radio-button>
            <el-radio-button label="3">专属版</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.card_version != '1'" label="企业管理员" prop="is_company_admin">
          <el-radio-group v-model="form.is_company_admin" size="mini">
            <el-radio-button label="-1">否</el-radio-button>
            <el-radio-button label="1">是</el-radio-button>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="公司名称" prop="company_name">
          <el-input v-model="form.company_name" size="mini" placeholder="请输入公司名称" style="width: 300px;"></el-input>
          <!-- <el-link v-if="form.card_version != '1'" type="primary" :underline="false" @click="bindCompanyDialogVisible = true" style="margin-left: 10px;">绑定公司</el-link> -->
        </el-form-item>
        <el-form-item label="职务" prop="job_title">
          <el-input v-model="form.job_title" size="mini" placeholder="请输入职务" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input v-model="form.address" type="textarea" :rows="2" size="mini" placeholder="请输入公司地址" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="多地址">
          <el-radio-group v-model="form.is_multiple_address" size="mini">
            <el-radio-button label="1">开启</el-radio-button>
            <el-radio-button label="-1">关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_multiple_address == '1'" label="其他地址">
          <div>
            <div v-for="(item, index) in addressList" :key="index">
              <el-input v-model="item.title" size="mini" placeholder="输入标题" style="width: 200px;margin-right: 10px;"></el-input>
              <el-input v-model="item.address" size="mini" placeholder="输入地址" style="width: 300px;margin-right: 10px;"></el-input>
              <el-input v-model="item.latitude" size="mini" placeholder="纬度坐标(latitude)" style="width: 150px;margin-right: 10px;"></el-input>
              <el-input v-model="form.longitude" size="mini" placeholder="经度坐标(longitude)" style="width: 150px;margin-right: 10px;"></el-input>
              <el-button v-if="index == addressList.length - 1" size="mini" plain style="margin-left: 10px;" @click="pushAddressItem" icon="el-icon-plus"></el-button>
              <el-button v-else-if="(index < addressList.length - 1) && addressList.length > 1" size="mini" plain style="margin-left: 10px;" @click="removeAddressItem(index)" icon="el-icon-minus" type="danger"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="纬度坐标(latitude)" prop="latitude">
          <el-input v-model="form.latitude" size="mini" placeholder="请输入地址纬度坐标" style="width: 300px;"></el-input>
          <span class="copy-link" v-clipboard:copy="form.address" v-clipboard:success="copyAddress" v-clipboard:error="onAddressCopyError">获取坐标</span>
        </el-form-item>
        <el-form-item label="经度坐标(longitude)" prop="longitude">
          <el-input v-model="form.longitude" size="mini" placeholder="请输入地址经度坐标" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="座机号" prop="telephone">
          <el-input v-model="form.telephone" size="mini" placeholder="请输入座机号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" size="mini" placeholder="请输入邮箱地址" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="weixin">
          <el-input v-model="form.weixin" size="mini" placeholder="请输入微信号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="微信二维码" prop="wxcode">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleWxcodeSuccess"
            :on-error="handleError">
            <img v-if="form.wxcode" :src="`${baseurl}/${form.wxcode}`" class="prview-pic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名片海报" prop="card_pic">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleCodePicSuccess"
            :on-error="handleError">
            <img v-if="form.card_pic" :src="`${baseurl}/${form.card_pic}`" class="cardpic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="电子画册编号" prop="ebook_no">
          <el-input v-model="form.ebook_no" size="mini" placeholder="请输入电子画册编号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="电子画册地址" prop="ebook_url">
          <el-input v-model="form.ebook_url" size="mini" placeholder="请输入电子画册地址" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="产品中心编号" prop="product_no">
          <el-input v-model="form.product_no" size="mini" placeholder="请输入产品中心编号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="企业简介" prop="desc_text">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleCompanyDescPicSuccess"
            :on-error="handleError">
            <img v-if="form.desc_images" :src="`${baseurl}/${form.desc_images}`" class="desc_images">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status" :disabled="bindResult == '2'" size="mini">
            <el-radio-button label="1">正常</el-radio-button>
            <el-radio-button label="2">停用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('ruleForm')">提 交</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 绑定公司弹窗 -->
    <el-dialog title="绑定公司" :visible.sync="bindCompanyDialogVisible" @close="bindCompanyDialogClose">
      <div>
        <el-input v-model="searchCompanyName" size="mini" clearable placeholder="请输入公司名称" @input="queryBindCompany" style="width: 300px;margin-right: 10px;"></el-input>
        <!-- <el-button type="primary" size="mini" @click="queryBindCompany">查询</el-button> -->
      </div>
      <el-table :data="companyList" v-loading="loading">
        <el-table-column property="info_no" label="公司编号" width="150"></el-table-column>
        <el-table-column property="name" label="公司名称" width="200"></el-table-column>
        <el-table-column property="address" label="公司地址"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="bindCompany(scope.row)">绑定</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UpdateStorePage',
  data() {
    return {
      form: {
        id: '',
        name: '', // 姓名
        photo_pic: '', // 头像地址
        sex: '', //  性别：1男，2女
        company_name: '美团', // 公司名称
        job_title: '', // 职务
        phone: '', // 手机号
        telephone: '', // 座机号
        email: '', // 邮箱
        address: '', // 公司地址
        weixin: '', // 微信号
        wxcode: '', // 微信二维码
        qrcode: '', // 名片二维码
        card_pic: '', // 名片海报
        is_agent: '', // 是否为代理：-1否，1合伙人，2二级代理，3一级代理
        invite_code: '', // 邀请码
        invite_code_url: '', // 邀请码图片地址
        income_balance: 0, // 佣金余额
        fee_balance: 0, // 代理预存余额
        card_temp: '', // 名片模板编号
        latitude: '', // 纬度
        longitude: '', // 经度
        view_count: 0, // 被查看次数
        show_ebook: '-1', // 是否展示电子画册：-1否，1是
        show_product: '-1', // 是否展示产品中心：-1否，1是
        show_website: '-1', // 是否展示微官网：-1否，1是
        show_mall: '-1', // 是否展示微商城：-1否，1是
        info_no: '', // 关联企业编号
        card_version: '1', // 名片版本：1基础版、2企业商务版、3企业专属版、4企业战略版
        is_company_admin: '-1', // 是否为企业版管理员：-1否，1是
        ebook_no: '', // 关联电子画册编号
        bookshelf_no: '', // 关联电子书架编号
        product_no: '', // 关联产品中心编号
        ebook_url: '', // 电子画册地址
        show_video: '', // 是否展示宣传视频：-1否，1是
        video_url: '', // 视频地址
        video_image: '', // 视频封面图片地址
        show_company_desc: '', // 是否展示企业简介：-1否，1是
        desc_format: '', // 企业简介展示形式：1长图，2文字
        desc_text: '', // 企业简介文本内容
        desc_images: '', // 企业介绍长图内容（图片地址数组）
        login_pwd: '', // 登录密码
        p_invite_code: '', // 上级邀请码
        p_invite_info: '', // 上级邀请人信息
        card_state: '', // 名片状态：-1取消创建，1待审核，2审核通过，3已冻结，4企业员工已离职
        account_num: '', // 返佣收款账号
        account_type: '3', // 账号类型：1支付宝，2微信，3银行卡
        account_notes: '', // 账号备注，例如银行卡开户行
        personal_version_opentime: '', // 个人版开通时间
        agent_state: '', // 合伙人申请状态：-1取消申请，1待审核，2审核通过，3已冻结
        other_address: '', // 其他地址json
        is_multiple_phone: '-1', // 是否多电话：1是，-1否
        is_multiple_address: '-1', // 是否多地址：1是，-1否
        status: '1', // 名片的状态：1启用，2停用
      },
      baseurl: '',
      uploadUrl: '',
      photoPicFile: null,
      photoPicPreviewUrl: '',
      headers: {
        'token': localStorage.getItem('weizhanToken')
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ]
      },
      bindCompanyDialogVisible: false,
      loading: false,
      companyList:[],
      searchCompanyName: '',
      inviteCode: '',
      phoneList: [
        { label: '', number: '' }
      ],
      addressList: [
        { title: '', address: '', latitude: '', longitude: '' }
      ]
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    this.uploadUrl = this.$uploadUrl
    this.generateUniqueId(0, 6, 'invite_code').then(res => {
      this.inviteCode = res
    })
    const finance = sessionStorage.getItem('updateFinance')
    if (finance) {
      this.form = JSON.parse(finance)
    } else {
      this.$message.warning('参数有误，请重新选择要修改的信息')
      this.$router.push({
        path: '/finance'
      })
    }
  },

  methods: {
    // 上传头像前的校验
    beforeUploadPhotoPic(file) {
      const isJPG = ['image/png','image/jpg','image/jpeg'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false
      }
      return isJPG && isLt2M
    },
    // 上传头像成功
    handleAvatarSuccess(res, file) {
      this.form.photo_pic = res.fileName
    },
    // 上传邀请二维码成功
    handleInviteCodeSuccess(res, file) {
      this.form.invite_code_url = res.fileName
    },
    // 上传微信二维码成功
    handleWxcodeSuccess(res, file) {
      this.form.wxcode = res.fileName
    },
    // 上传海报成功
    handleCodePicSuccess(res, file) {
      this.form.card_pic = res.fileName
    },
    // 上传企业简介成功
    handleCompanyDescPicSuccess(res, file) {
      this.form.desc_images = res.fileName
    },
    handleError(error, file, fileList) {
      this.$message.error('图片上传失败')
    },
    goBack() {
      this.$router.back()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 复制并生成二维码
    copyInviteCode(e) {
      window.open('https://cli.im/', '_blank')
    },
    // 获取坐标信息
    copyAddress() {
      if (this.form.address == '') {
        this.$message.warning('请先输入地址')
      } else {
        this.$message.success('已复制地址')
        window.open('https://lbs.qq.com/getPoint/', '_blank')
      }
    },
    // 地址复制失败
    onAddressCopyError() {
      this.$message.warning('请先输入地址')
    },
    // 复制失败
    onCopyError() {
      this.$message.error('复制失败')
    },
    // 增加电话号
    addPhoneItem() {
      this.phoneList.push({ label: '', number: '' })
    },
    // 删除手机号
    removePhoneItem(index) {
      this.phoneList.splice(index, 1)
    },
    // 增加地址
    pushAddressItem() {
      this.addressList.push({ title: '', address: '', latitude: '', longitude: '' })
    },
    // 删除地址
    removeAddressItem(index) {
      this.addressList.splice(index, 1)
    },
    // 是否为代理
    handleAgentChange(val) {
      if (val == '1') {
        this.form.invite_code = this.inviteCode
        this.form.fee_balance = 0
      } else if (val == '2') {
        this.form.invite_code = this.inviteCode
        this.form.fee_balance = 10000
      } else if (val == '3') {
        this.form.invite_code = this.inviteCode
        this.form.fee_balance = 30000
      } else if (val == '-1') {
        this.form.invite_code = ''
        this.form.fee_balance = 0
      }
    },
    // 选择代理版本
    handleCardVersionChange(val) {
      console.log('代理版本：', val);
      if (val == '1') {
        this.form.is_company_admin = '-1'
      }
    },
    // 绑定公司
    queryBindCompany() {
      if (this.searchCompanyName !== '') {
        this.loading = true;
        this.$http({
          method: 'post',
          url: '/information/findall',
          params: {
            name: this.searchCompanyName
          }
        })
        .then(res => {
          if (res.errno == 0) {
            if (res.data.data && res.data.data.length > 0) {
              this.companyList = res.data.data
              this.loading = false;
            } else {
              this.loading = false;
            }
          } else {
            this.$message.error('查询失败')
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error('查询失败，服务端异常')
          console.error('操作异常：', err.message);
          this.loading = false;
        })
      } else {
          this.companyList = [];
      }
      
    },
    // 绑定公司
    bindCompany(row) {
      if (row.card_version == '1') {
        this.$message.warning('个人版名片无法绑定公司')
        return
      }
      this.form.info_no = row.info_no
    },
    // 绑定公司弹框关闭
    bindCompanyDialogClose() {
      this.searchCompanyName = ''
      this.companyList = []
    },
    getCurrentTime() {
      const now = new Date();
  
      // 获取年、月、日、时、分、秒
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      // 拼接成指定格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 生成唯一编号
    async  generateUniqueId(prefixLength = 2, numberLength = 6, type = 'user_no') {
      const characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ';
      const numbers = '123456789';

      let prefix = '';
      for (let i = 0; i < prefixLength; i++) {
          prefix += characters.charAt(Math.floor(Math.random() * characters.length));
      }

      let numberPart = '';
      for (let i = 0; i < numberLength; i++) {
          numberPart += numbers.charAt(Math.floor(Math.random() * numbers.length));
      }

      let userNo = prefix + numberPart

      let params = {}
      if (type == 'user_no') {
        params = {user_no: userNo}
      } else if (type == 'invite_code') {
        params = {invite_code: userNo}
      }

      let res = await  this.$http({method: 'post',url: '/personal/findall',params})
      
      if (res.errno == 0) {
        if (res.data.data && res.data.data.length == 0) {
          return userNo
        } else {
          this.generateUniqueId(prefixLength, numberLength)
        }
      } else {
        this.generateUniqueId(prefixLength, numberLength)
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            if (this.form.is_multiple_phone == '1') {
              this.form.telephone = JSON.stringify(this.phoneList)
            }
            if (this.form.is_multiple_address == '1') {
              this.form.other_address = JSON.stringify(this.addressList)
            }
            this.$http({
              method: 'post',
              url: '/personal/update',
              params: {
                ...this.form,
                update_time: this.getCurrentTime()
              }
            })
            .then(res => {
              if (res.errno == 0) {
                this.$message.success('修改成功')
                this.resetForm('ruleForm')
                this.goBack()
              } else {
                this.$message.error('修改失败')
              }
            })
            .catch(err => {
              this.$message.error('修改失败，服务端异常')
              console.error('操作异常：', err.message);
            })
        } else {
          return false;
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }

  .form-layout {
    margin: 30px 0px;
    padding: 10px 30px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  width: 120px;
  height: 120px;
}
.avatar-uploader-icon:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.prview-pic {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.cardpic {
    width: 200px;
    height: 100px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.desc_images {
  height: 100px;
  border: 1px solid red;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}
.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
</style>